import {CommonMessages} from '../common.messages';

export const PanelSettingsMessagingMessages = {
    GetMessageTemplatesFailed: {
        key: 'GetMessageTemplatesFailed',
        message: 'Error while communication with the server. Unable to get message templates.'
    },
    GetEmailTemplatesFailed: {
        key: 'GetEmailTemplatesFailed',
        message: 'Error while communication with the server. Unable to get email templates.'
    },
    GetEmailTemplateByIdFailed: {
        key: 'GetEmailTemplateByIdFailed',
        message: 'Error while communication with the server. Unable to get email template by id.'
    },
    UpdateEmailTemplateFailed: {
        key: 'UpdateEmailTemplateFailed',
        message: 'Error while communication with the server. Unable to update email template.'
    },
    CreateEmailTemplateFailed: {
        key: 'CreateEmailTemplateFailed',
        message: 'Error while communication with the server. Unable to create email template.'
    },
    CreateEmailTemplateSucceeded: {
        key: 'CreateEmailTemplateSucceeded',
        message: 'Email template is successfully created.'
    },
    GetMessageTemplateByIdFailed: {
        key: 'GetMessageTemplateByIdFailed',
        message: 'Error while communication with the server. Unable to get message template by id.'
    },
    UpdateMessageTemplateFailed: {
        key: 'UpdateMessageTemplateFailed',
        message: 'Error while communication with the server. Unable to update message template.'
    },
    CreateMessageTemplateFailed: {
        key: 'CreateMessageTemplateFailed',
        message: 'Error while communication with the server. Unable to create message template.'
    },
    CreateMessageTemplateSucceeded: {
        key: 'CreateMessageTemplateSucceeded',
        message: 'Message template is successfully created.'
    },
    ...CommonMessages
};
